/**
 * Filter the entries in an object by a predicate of the values in the object
 */
export default function objectFilter<T>(o: { [key: string]: T }, pred: (v: T) => boolean) {
  if (!o) {
    return o;
  }
  const onew: { [key: string]: T } = {};
  for (const key in o) {
    if (!pred(o[key])) {
      continue;
    }
    onew[key] = o[key];
  }
  return onew;
}
